import React, {useState, useEffect} from 'react'
import {MDBCard, MDBBtn} from "mdbreact";
import classes from './SocialComment.module.css'
import DatePicker from 'react-datepicker';
import {timeStampToString} from "../../../../Utils/converter";
import firebase from "../../../../Config/firebase";

const db = firebase.firestore()

const NewSocialComment = (props) => {
    const [newSocialComment, setNewSocialComment] = useState({
        content: "",
        createDate: new Date(),
        createUserID: props.auth.uid,
        sourceDate: new Date(),
        sourceName: "",
        sourceUrl: "",
        sourceUserName: ""
    })
    const [isSubmitted, setIsSubmitted] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isError, setIsError] = useState(false)

    const submitNewSComment = () => {
        setIsSubmitting(true)
        if (newSocialComment.content === '') {
            setIsError(true)
        } else {

            console.log(newSocialComment)
            setIsError(false)
            db.collection('Community')
                .doc(props.cid)
                .collection('WebComment')
                .add(newSocialComment)
                .then(res => {
                    setIsSubmitted(false)
                    props.returnNewSocialMediaComment(newSocialComment)
                    //reset
                    setTimeout(() => {
                        setNewSocialComment({
                            content: "",
                            createDate: new Date(),
                            createUserID: "",
                            sourceDate: new Date(),
                            sourceName: "",
                            sourceUrl: "",
                            sourceUserName: ""
                        })
                    }, 500)

                })
                .catch(err => console.log(err))
        }
    }

    return (
        <MDBCard className={classes.NewSocialComment}>
            <div className={classes.SocialCommentTop}>
                <div className={classes.SourceContainer}>
                    <input type='text'
                           placeholder={'e.g. Flora'}
                           className={classes.AddFeatureInput}
                           value={newSocialComment.sourceUserName}
                           onChange={(e) => setNewSocialComment({
                               ...newSocialComment,
                               sourceUserName: e.target.value
                           })}/>
                    <div>@</div>
                    <input type='text'
                           placeholder={'e.g. 教育王國'}
                           className={classes.AddFeatureInput}
                           value={newSocialComment.sourceName}
                           onChange={(e) => setNewSocialComment({
                               ...newSocialComment,
                               sourceName: e.target.value
                           })}/>
                </div>

                <div className={classes.SourceDate}>
                    <label className={classes.Label}>
                        訪問日期
                    </label>
                    <DatePicker selected={newSocialComment.sourceDate}
                                className={classes.DatePicker}
                                onChange={date => {
                                    console.log(new Date(date))
                                    setNewSocialComment({
                                        ...newSocialComment,
                                        sourceDate: date
                                    })
                                }}/>
                    {/*{timeStampToString(props.data.sourceDate.seconds)}*/}
                </div>

                <div className={classes.SourceDate}>
                    <label className={classes.Label}>
                        來源連結
                    </label>
                    <input type='text'
                           placeholder={'e.g. https://clipversity.com'}
                           className={classes.AddFeatureInput}
                           value={newSocialComment.sourceUrl}
                           onChange={(e) => setNewSocialComment({
                               ...newSocialComment,
                               sourceUrl: e.target.value
                           })}/>
                    {/*{timeStampToString(props.data.sourceDate.seconds)}*/}
                </div>


            </div>

            <div>
               <textarea className={classes.CommentTextbox}
                         placeholder={'討論內容'}
                         value={newSocialComment.content}
                         onChange={(e) => {
                             setNewSocialComment({
                                 ...newSocialComment,
                                 content: e.target.value
                             })
                         }}
               />
            </div>
            <button className={classes.SubmitBtn} onClick={() => submitNewSComment()}>
                新增
            </button>


        </MDBCard>
    )
}
export default NewSocialComment